import React, { Component } from 'react';
import { connect } from 'react-redux';
import Dropzone from 'react-dropzone';
import Modal from '@mui/material/Modal';
import { Close as CloseIcon } from '@mui/icons-material';

import { globalStyles } from '../theme/index.js';
import { Text, Button, Theme, Content } from '@simplybenefits/sb-ui-library';
import * as notifier from '../actions/notifier.js';
import { styled } from '@mui/system';

import csvImage from '../assets/csv.png';
import docImage from '../assets/doc.png';
import imgImg from '../assets/img.png';
import jsonImg from '../assets/json.png';
import pdfImg from '../assets/pdf.png';
import xlsImg from '../assets/xls.png';

const StyledPreviewStyle = styled('div')(({ theme }) => ({
    minHeight: '315px',
    minWidth: '285px',
    backgroundColor: Theme.colors.surface,
    borderRadius: '8px',
    padding: '10px',
    marginLeft: '5px',
    margin: '5px',
    wordBreak: 'break-all',
    [theme.breakpoints.down('666')]: {
        minWidth: 'fit-content'
    }
}));

class FileDropZoneModal extends Component {
    state = {
        showContactModal: false,
        files: [],
        fileName: '',
        showDropzone: true
    };

    _chooseDocument = async (files) => {
        if (!this.props.acceptMultiple && files[1] !== null) {
            files = await new Array(files[0]);
        }

        const valid = files[0];

        if (!valid) {
            await this.props.dispatch(notifier.displayError({
                verbiage: 'File seems to be corrupt, or unaccepted file type. Please select a different file.'
            }));

            return false;
        }

        const duplicate = this.state.files.length > 0 && this.state.files[0].name === files[0].name;

        if (valid && !duplicate) {
            this.setState({
                fileName: files[0].name,
                files: [ ...this.state.files, ...files ]
            });
        } else {
            this.props.dispatch(notifier.displayError({
                verbiage: 'File already selected, please select a different file.'
            }));
        }

        await this.setState({
            showDropzone: this.state.files.length < this.props.maxItems
        });

        return true;
    };

    _fileType = (file) => {
        let fileType = null;

        switch (file.type) {
            case 'application/xlsx':
                fileType = xlsImg;
                break;
            case 'application/vnd.ms-excel':
                fileType = xlsImg;
                break;
            case 'text/csv':
                fileType = csvImage;
                break;
            case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
                fileType = docImage;
                break;
            case 'image/jpeg':
                fileType = imgImg;
                break;
            case 'image/jpg':
                fileType = imgImg;
                break;
            case 'image/png':
                fileType = imgImg;
                break;
            case 'application/json':
            case 'text/json':
                fileType = jsonImg;
                break;
            default:
                fileType = pdfImg;
                break;
        }

        return fileType;
    };

    _fileName = (file) => {
        let filename = null;
        file.name.length > 25 ? filename = `${ file.name.substr(0, 11) }...${ file.name.substr(-11) }` : filename = file.name;
        return filename;
    };

    _removeDocument = async (name) => {
        const fileArray = this.state.files.filter((file) => file.name !== name);

        await this.setState({
            files: fileArray,
            showDropzone: true
        });
    };

    _submitDocument = async () => {
        if (this.state.files.length > 0) {
            const submit = await this.props.submitFile(this.state.files, this.props.type);
            this.props.hideModal();
            return submit;
        }

        return null;
    };

    handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            return this._submitDocument();
        }

        return false;
    };

    render() {
        const { showModal, hideModal, title, acceptedFiles, testid, instructions, warning } = this.props;
        const { showDropzone } = this.state;
        const styles = {
            container: globalStyles.container,
            content: globalStyles.content,
            btnWidth: {
                width: 'fit-content',
                marginLeft: 'auto'
            },
            modal: {
                top: '50%',
                left: '50%',
                margin: '0',
                maxWidth: '40%',
                minWidth: '648px',
                outline: 'none',
                position: 'absolute',
                boxShadow: '0 1px 2px rgba(0, 0, 0, .15)',
                borderRadius: '12px',
                transform: 'translate(-50%, -50%)',
                WebkitTransform: 'translate(-50%, -50%)'
                // [theme.breakpoints.down('666')]: {
                //     maxWidth: '75%',
                //     minWidth: 'unset'
                // }
            },
            modalBody: {
                display: 'flex',
                flexDirection: 'column',
                flexWrap: 'wrap',
                justifyContent: 'space-around',
                borderRadius: '12px',
                padding: '20px',
                backgroundColor: Theme.colors.surface
            },
            closeModalIcon: {
                cursor: 'pointer',
                display: 'inline',
                marginTop: '5px',
                fontSize: '22px',
                float: 'right',
                color: Theme.colors.mainTextGrey
            },
            titleIconWrapper: {
                display: 'block',
                width: '100%',
                paddingBottom: '15px',
                verticalAlign: 'center'
            },
            cardStyle: {
                backgroundColor: Theme.colors.lightBlue,
                boxShadow: 'none',
                padding: '20px',
                border: `2px dotted ${ Theme.colors.mediumBlue }`,
                borderRadius: '8px',
                textAlign: 'center',
                color: Theme.colors.mediumBlue
            },
            cardDisabled: {
                backgroundColor: Theme.colors.lightGrey,
                boxShadow: 'none',
                padding: '20px',
                border: `2px dotted ${ Theme.colors.mediumLightGrey }`,
                borderRadius: '8px',
                color: Theme.colors.mediumLightGrey
            },
            previewWrapper: {
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap',
                justifyContent: 'space-around',
                alignItems: 'center',
                marginBottom: '10px',
                backgroundColor: Theme.colors.lightGrey,
                boxShadow: 'none',
                padding: '5px',
                borderRadius: '8px'
            },
            fileTitle: {
                maxWidth: '300px',
                wordBreak: 'break-all'
            },
            logo: globalStyles.logo
        };

        return (
            <Modal
                open={showModal}
                onClose={hideModal}
                style={{ overflow: 'auto', 'WebkitOverflowScrolling': 'touch' }}
            >
                <Content
                    style={styles.modal}
                    onKeyPress={ this.handleKeyPress }
                >
                    <div style={styles.modalBody}>

                        <div style={styles.titleIconWrapper}>
                            <CloseIcon
                                style={styles.closeModalIcon}
                                onClick={hideModal}
                            />

                            <Text
                                align="center"
                                bold
                                mediumLarge
                                display="inline-block"
                                margin="0"
                            >
                                { title }
                            </Text>
                        </div>

                        {
                            instructions &&
                                <div style={styles.titleIconWrapper}>
                                    <Text
                                        align="left"
                                        display="inline-block"
                                        margin="0"
                                        small
                                    >
                                        { instructions }
                                    </Text>
                                </div>
                        }

                        {
                            this.props.downloadTemplate &&
                                <Button
                                    onClick={this.props.downloadTemplate}
                                    transparent
                                    customStyle={{ width: "100%" }}
                                >
                                    Download blank template
                                </Button>
                        }

                        {
                            warning &&
                                <div style={styles.titleIconWrapper}>
                                    <Text
                                        align="left"
                                        bold
                                        medium
                                        display="inline-block"
                                        margin="0"
                                        color={Theme.colors.red}
                                    >
                                        { warning }
                                    </Text>
                                </div>
                        }

                        {
                            this.state.files.length > 0 &&
                                <React.Fragment>
                                    <div style={styles.previewWrapper} >
                                        {
                                            this.state.files.map((file) => {
                                                const fileType = this._fileType(file);
                                                const fileName = this._fileName(file);

                                                return (
                                                    <StyledPreviewStyle key={file.name}>
                                                        <CloseIcon
                                                            style={styles.closeModalIcon}
                                                            onClick={() => this._removeDocument(file.name)}
                                                        />

                                                        <img
                                                            alt="File type icon"
                                                            src={ fileType }
                                                            style={styles.logo}
                                                        />

                                                        <Text
                                                            align="center"
                                                            bold
                                                            mediumLarge
                                                            display="block"
                                                            margin="0"
                                                            customStyle={{ maxWidth: 300 }}
                                                        >
                                                            { fileName }
                                                        </Text>

                                                    </StyledPreviewStyle>
                                                );
                                            })
                                        }
                                    </div>
                                </React.Fragment>
                        }

                        {
                            this.state.showDropzone &&
                                <Dropzone
                                    onDrop={(files) => this._chooseDocument(files)}
                                    accept={acceptedFiles || "image/png, image/jpeg, image/jpg, text/csv, .csv, .xls, .xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}
                                >
                                    {({ getRootProps, getInputProps }) => (
                                        <section>
                                            <div {...getRootProps()} style={!showDropzone ? styles.cardDisabled : styles.cardStyle}>
                                                <input {...getInputProps()} />
                                                <Text testid={testid} color="skyBlue" margin="20px 0" small align="center">
                                                    Drag and drop your files here, or click to select...
                                                </Text>
                                            </div>
                                        </section>
                                    )}
                                </Dropzone>
                        }

                        {
                            acceptedFiles &&
                                <Text margin="10px 0 0" align="center" tiny>
                                    {acceptedFiles}
                                </Text>
                        }

                        <Button
                            disabled={this.state.files.length === 0}
                            onClick={this._submitDocument}
                            color="primary"
                            customStyle={styles.btnWidth}
                            marginTop="20px"
                        >
                            Submit
                        </Button>
                    </div>
                </Content>
            </Modal>
        );
    }
}

export default (connect()(FileDropZoneModal));